<div class="t-widget">
  <h3>
    {{ "translate.rx.implants" | translate }}
  </h3>

  <div class="tbl-implants dense">
    <div class="p-datatable iscs-table iscs-table-auto">
      <table class="p-datatable-table">
        <thead class="p-datatable-thead">
          <tr>
            <th>{{ "translate.rx.teeth" | translate }}</th>
            <th>{{ "translate.rx.impType" | translate }}</th>
            <th>
              {{ "translate.rx.impCompany" | translate }}
            </th>
            <th>
              {{ "translate.rx.impDiameter" | translate }}
            </th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody class="p-datatable-tbody">
          <tr
            *ngFor="let row of implants"
            (mouseenter)="readOnly ? null : (curRow = row)"
            (mouseleave)="curRow = null"
          >
            <td>{{ row.id }}</td>
            <td>
              <rx-opt-display
                [opt]="row.implantType"
                [label]="false"
                [readOnly]="readOnly"
                (onOptValueChange)="onImplantTypeValueChange()"
              ></rx-opt-display>
            </td>
            <td>
              <rx-opt-display
                [opt]="row.implantCompany"
                [label]="false"
                (onOptValueChange)="onCompanyValueChange($event)"
                [readOnly]="readOnly"
              ></rx-opt-display>
            </td>
            <td>
              <rx-opt-display
                [opt]="row.implantDiameter"
                [label]="false"
                [readOnly]="readOnly"
                (onOptValueChange)="onOptValueChange()"
              ></rx-opt-display>
            </td>
            <td>
              <rx-opt-display
                [class.hidden]="row.implantType.selectedValue?.id == null"
                [opt]="row.implantType.selectedValue?.id == 'CEMENT' ? 
                  row.implantIndivSw : row.implantMultiUnitSw"
                [singleLine]="true"
                [readOnly]="readOnly"
                (onOptValueChange)="onOptValueChange()"
              ></rx-opt-display>
            </td>
            <td class="icon-delete">
              <a [class.hidden]="curRow != row" (click)="deleteRow(row)">
                <img src="assets\img\Delete_small.svg"
              /></a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <ng-container *ngIf="attachments">
    <h4>{{ "translate.rx.attachments" | translate }}</h4>
    <div class="rx-opt-container attach">
      <div class="opt" *ngFor="let opt of attachments.options">
        <rx-opt-display
          [opt]="opt"
          [readOnly]="readOnly"
          (onOptValueChange)="onOptValueChange()"
        ></rx-opt-display>
      </div>
    </div>
  </ng-container>
</div>
